/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Url_LabelInputs */

const en_directory_vibebids_url_label = /** @type {(inputs: Directory_Vibebids_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your product URL or handle`)
};

const zh_directory_vibebids_url_label = /** @type {(inputs: Directory_Vibebids_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品网址或账号`)
};

/**
* | output |
* | --- |
* | "Your product URL or handle" |
*
* @param {Directory_Vibebids_Url_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_url_label = /** @type {((inputs?: Directory_Vibebids_Url_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Url_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_url_label(inputs)
	return zh_directory_vibebids_url_label(inputs)
});
export { directory_vibebids_url_label as "directory.vibebids.url_label" }